import { useCallback } from "react"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { LandingIntegrationEntity } from "../../Objects/Landing/LandingIntegrationEntity"
import { GetRequest } from "../../services/ApiClientService"

export const useGetLandingIntegrations = () => {
  const handleGetLandingIntegrations = useCallback(async () => {
    const response = await GetRequest<LandingIntegrationEntity[]>(API_ROUTES.LANDING.GET_INTEGRATIONS)

    if (!response.success) {
      throw new Error(response.message || "Erro ao buscar integrações da landing.")
    }

    return (response.data ?? [])
      .map((item) => new LandingIntegrationEntity(item))
      .sort((a, b) => a.displayOrder - b.displayOrder)
  }, [])

  return { handleGetLandingIntegrations }
}
